// ============================================================
// resolveUIState — pure function, no React dependencies.
// Takes raw server state, returns UI flag object for ChatConversation.
// Fully testable in isolation.
// ============================================================

export function resolveUIState(serverState) {
  if (!serverState) return {};
  const {
    myGender, isHetero, fsmState,
    comfortBufferActive, comfortBufferUsed, coordinationActive,
    decisionGateAvailable,
    canInitiateSpotting, isSpottingResponder, isSpottingConfirmer,
    canSkipToChat, canShareAndAsk, canAskOnly,
    alreadySharedHandle, socialExchangePending, bothHandlesShared,
    identityStatus, identityActionChosen, identityReverseUnlocked,
    pendingStructuredQ, pendingSocialQ, pendingMeetQ, iSentMeetQ,
    myMessagesRemaining, currentPhase, sectionsEnabled
  } = serverState;

  const responderNeedsAction      = isSpottingResponder && (!identityActionChosen || identityActionChosen === 'tied_up');
  const responderChoseTiedUp      = isSpottingResponder && identityActionChosen === 'tied_up';

  const pendingSocialIsForMe      = !!pendingSocialQ;

  const showDecisionGateCard      = decisionGateAvailable && !coordinationActive && !comfortBufferActive && fsmState === 'STATE_C';
  const isHeteroMan               = isHetero && myGender === 'male';
  const showBriefChatButton       = decisionGateAvailable && !comfortBufferUsed && !comfortBufferActive && !coordinationActive && (!showDecisionGateCard || isHeteroMan);

  const showFreeText              = comfortBufferActive || coordinationActive;
  const freeTextDisabled          = myMessagesRemaining <= 0;

  let phaseLabel = null;
  if (currentPhase === 'comfort_buffer') phaseLabel = 'Intro Chat';
  else if (currentPhase === 'coordination') phaseLabel = 'Meeting Coordination';

  return {
    showInitiateSpottingBtn:  canInitiateSpotting,
    showSpotMeBtn:            responderNeedsAction,
    showTiedUpAlert:          responderChoseTiedUp,
    showSpottingConfirmCard:  isSpottingConfirmer,
    showSocialSection:        true,
    pendingSocialIsForMe,
    canRespondWithHandle:     pendingSocialIsForMe && !alreadySharedHandle,
    showShareAndAskBtn:       canShareAndAsk && !socialExchangePending && !pendingSocialIsForMe,
    showAskOnlyBtn:           canAskOnly && !socialExchangePending && !pendingSocialIsForMe,
    showRecipAskAfterShare:   alreadySharedHandle && !socialExchangePending && !pendingSocialIsForMe && !bothHandlesShared,
    showMeetSection:          sectionsEnabled?.D,
    meetIsCoordinating:       coordinationActive,
    meetIsConfirmed:          fsmState === 'MEETING_CONFIRMED',
    pendingMeetQ,
    iSentMeetQ,
    showDecisionGateCard,
    showBriefChatButton,
    showSkipToChat:           canSkipToChat,
    showFreeText,
    freeTextDisabled,
    phaseLabel,
    structuredQsBlocked:      !!pendingStructuredQ || !!pendingMeetQ
  };
}
